import type { AdminJsonComponentConfig } from '@apps/websiteCustomJsonComponents/types';
import { createLazyComponentFromNamedExport } from '@shared/utils/createLazyComponent';
import { DefaultThingsToDoGrabber } from './DefaultThingsToDoSidebar';
import { DEFAULT_THINGS_TO_DO_SCHEMA_URL, DEFAULT_THINGS_TO_DO_COMPONENT_TYPE } from './DefaultThingsToDo.constants';

const DefaultThingsToDoEdit = createLazyComponentFromNamedExport(
  () => import(/* webpackChunkName: "content/websiteEditorDefaultThingsToDoEdit" */ './DefaultThingsToDoEdit'),
  'DefaultThingsToDoEdit',
);

// Add this object to CUSTOM_JSON_COMPONENT_TYPES in
// src/apps/websiteCustomJsonComponents/config.ts
export const DefaultThingsToDoConfig: AdminJsonComponentConfig = {
  schemaUrl: DEFAULT_THINGS_TO_DO_SCHEMA_URL,
  componentType: DEFAULT_THINGS_TO_DO_COMPONENT_TYPE,
  adminSidebarComponent: {
    addComponentView: () => null,
    dragComponentView: DefaultThingsToDoGrabber,
    editComponentView: DefaultThingsToDoEdit,
    createComponentView: DefaultThingsToDoEdit,
  },
};
